import React, { useState } from 'react'
import editAboutApp from '../../apis/editAboutApp'

const About = ({ data, refresh }) => {
  console.log(data)
  const [activeTab, setActiveTab] = useState('english') // Default tab is English
  const [loading, setLoading] = useState(false)
  const [notes, setNotes] = useState(data?.notes)
  const [arabicContent, setArabicContent] = useState(data?.description_er)
  const [englishContent, setEnglishContent] = useState(data?.description_en)

  const handleEditPrivacy = async (type) => {
    let formData = new FormData()
    setLoading(true)
    if (type === 'notes') {
      try {
        if (notes !== data.notes) {
          formData.append('notes', notes)
          await editAboutApp(formData)
          refresh()
        }
      } catch (error) {}
    } else if (type === 'en') {
      try {
        if (englishContent !== data.description_en) {
          formData.append('description_en', englishContent)
          await editAboutApp(formData)
          refresh()
        }
      } catch (error) {}
    } else {
      try {
        if (arabicContent !== data.description_er) {
          formData.append('description_er', arabicContent)
          await editAboutApp(formData)
          refresh()
        }
      } catch (error) {
      } finally {
        setLoading(false)
      }
    }
  }

  return (
    <div>
      <div className="flex space-x-4 mb-4">
        <button
          className={`py-2 px-4 ${
            activeTab === 'english'
              ? ' text-white bg-blueButton rounded-md border-b-[2px]'
              : 'bg-gray rounded-md text-white'
          }`}
          onClick={() => setActiveTab('english')}
        >
          English
        </button>
        <button
          className={`py-2 px-4 ${
            activeTab === 'arabic'
              ? ' text-white bg-blueButton rounded-md border-b-[2px]'
              : 'bg-gray rounded-md text-white'
          }`}
          onClick={() => setActiveTab('arabic')}
        >
          Arabic
        </button>
      </div>

      <div className="bg-white h-[60vh] gap-3 flex justify-center items-stretch ">
        <div className=" w-3/4 rounded shadow p-2">
          {activeTab === 'english' ? (
            <div className=" w-full flex flex-col gap-2 h-full">
              <h2 className="text-xl font-bold mb-2">About App (English)</h2>
              <div className=" w-full h-[80%] border-darkBlue overflow-auto border-[1px] rounded">
                <textarea
                  value={englishContent}
                  onChange={(e) => setEnglishContent(e.target.value)}
                  className=" w-full h-full p-2 rounded focus:outline-none "
                />
              </div>
              <button
                disabled={loading}
                onClick={() => handleEditPrivacy('en')}
                className="w-full flex gap-2 justify-center items-center py-2 px-5 disabled:bg-blueButton/60 bg-blueButton transition-all duration-300 text-xl hover:scale-105 text-white text-center rounded-xl"
              >
                {loading && (
                  <div
                    style={{
                      borderColor: `#A9A9A9 transparent #A9A9A9 transparent`,
                    }}
                    className="border-2 w-4 h-4 aspect-square animate-spin rounded-full"
                  ></div>
                )}
                <span>{loading ? 'upadting...' : 'update EN Content'}</span>
              </button>
            </div>
          ) : (
            <div className=" w-full flex flex-col gap-2 h-full">
              <h2 className="text-xl text-end font-bold mb-2">من نحن(عربي)</h2>
              <div className=" w-full h-[80%] border-darkBlue overflow-auto border-[1px] rounded">
                <textarea
                  dir="rtl"
                  value={arabicContent}
                  onChange={(e) => setArabicContent(e.target.value)}
                  className=" p-2 w-full h-full rounded focus:outline-none "
                />
              </div>
              <button
                disabled={loading}
                onClick={() => handleEditPrivacy('ar')}
                className="w-full flex gap-2 justify-center items-center py-2 px-5 disabled:bg-blueButton/60 bg-blueButton transition-all duration-300 text-xl hover:scale-105 text-white text-center rounded-xl"
              >
                {loading && (
                  <div
                    style={{
                      borderColor: `#A9A9A9 transparent #A9A9A9 transparent`,
                    }}
                    className="border-2 w-4 h-4 aspect-square animate-spin rounded-full"
                  ></div>
                )}
                <span>{loading ? 'upadting...' : 'update AR Content'}</span>
              </button>
            </div>
          )}
        </div>
        <div className="p-4 w-1/4 rounded shadow flex flex-col justify-between">
          <div className=" w-full b-2 ">Notes</div>
          <div className=" w-full h-[80%] border-darkBlue overflow-auto border-[1px] rounded">
            <textarea
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              className=" w-full h-full rounded focus:outline-none "
            />
          </div>
          <div>
            <button
              disabled={loading}
              onClick={() => handleEditPrivacy('notes')}
              className="w-full flex gap-2 justify-center items-center py-2 px-5 disabled:bg-blueButton/60 bg-blueButton transition-all duration-300 text-xl hover:scale-105 text-white text-center rounded-xl"
            >
              {loading && (
                <div
                  style={{
                    borderColor: `#A9A9A9 transparent #A9A9A9 transparent`,
                  }}
                  className="border-2 w-4 h-4 aspect-square animate-spin rounded-full"
                ></div>
              )}
              <span>{loading ? 'upadting...' : 'update notes'}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
